import { CategoryOperator, ComparisonOperator, QuickTypeEnum, SortBy } from "@shared/types/enums/globalEnum";
import { OptionType } from "../types";
import { IFilterResource } from "../../features/resources/services/types/resourceEntity";
import { EDateSeparator } from "../../features/settings/services/entities/enum";

export const listQuestionsStart = [
  {
    title: "Where do your meetings usually take place?",
    description: "To improve our recommendations for you we would like you to enter your normal location",
  },
  {
    title: "What do you use most?",
    description: "To enable quicker and better search please chose you prefered resource type",
  },
];

export const titlePages = {
  recommendation: {
    title: "Recommended for you",
    description: "Click on resource to pick",
  },
  selectedResources: {
    title: "Selected Resources",
  },
  setting: {
    title: "Setting",
  },
  changeTime: {
    title: "Attendees",
  },
  search: {
    title: "Search",
  },
  findColleague: {
    title: "Find Colleague",
  },
  quickSetting: {
    title: "Quick button setting",
  },
  findFavorite: {
    title: "Favorite",
    description: "Click on resource to pick",
  },
  findMostUsed: {
    title: "Most Used",
    description: "Click on resource to pick",
  },
  quickSearchColleagues: {
    title: "Colleagues",
  },
  quickSearchResource: {
    title: "Resources",
  },
};

export const tooltipText = {
  back: "Back",
  search: "Search",
  floorPlan: "Floor Plan",
  expand: "Expand",
  setting: "Setting",
  resourceSelected: "Selected resources",
  info: "View details",
  removeFromMyFavorites: "Remove from My Favorites",
  addToMyFavorites: "Add to My Favorites",
  calendar: "Calendar",
  remove: "Remove",
  findColleague: "Find Colleague",
  findColleagueNoSupportRecurring: "Find colleague (Not available for recurring meetings)",
  favorite: "Favorite - Most Used",
  conflict: "Conflict",
  approved: "Approved",
  agent: "Agent",
  recommend: "Recommended for you",
  testAuth: "Auth Test",
};

export const quickTypeOptions = [
  { label: "Colleagues", value: QuickTypeEnum.Colleagues },
  { label: "Resources", value: QuickTypeEnum.Resources },
];

export const mailFlowOptions = [
  { label: "Only primary organizer", value: 0 },
  { label: "Only assistant organizer", value: 1 },
  { label: "Primary AND assistant organizer", value: 2 },
];

export const defaultPagination = {
  pageSizeFindRecentColleague: 4,
  pageSize: 10,
  pageNumber: 1,
  pageSizeFindMeetingColleagues: 100,
}

// Filter resources

export const availableOptions = [
  { label: "Available", value: true },
  { label: "All", value: false },
] as OptionType[];

export const comparisonOperatorOptions = [
  {
    label: "More than >=",
    value: ComparisonOperator.MoreThan,
  },
  {
    label: "Equals =",
    value: ComparisonOperator.Equal,
  },
  {
    label: "Less than <=",
    value: ComparisonOperator.LessThan,
  },
] as OptionType[];

export const sortByOptions = [
  {
    label: "Name A-Z",
    value: SortBy.NameAsc,
  },
  {
    label: "Name Z-A",
    value: SortBy.NameDesc,
  },
  {
    label: "Capacity 1-9",
    value: SortBy.CapacityAsc,
  },
  {
    label: "Capacity 9-1",
    value: SortBy.CapacityDesc,
  },
] as OptionType[];

export const filterResourceDefault = {
  textSearch: "",
  status: true,
  capacityOperator: ComparisonOperator.MoreThan,
  capacityValue: 0,
  sortBy: SortBy.NameAsc,
  categories: [],
  categoryOperator: CategoryOperator.Or,
  locations: [],
  resourceType: "",
} as IFilterResource;

export const timeFormatOptions = [
  { label: "HH:mm (13:10)", value: "HH:mm" },
  { label: "hh:mm tt (01:10 PM)", value: "hh:mm A" },
  { label: "H:mm (13:10)", value: "H:mm" },
  { label: "h:mm tt (1:10 PM)", value: "h:mm A" },
] as OptionType[];

export const dateFormatOptions = [
  { label: "dd-MM-yyyy (09-01-2026)", value: "DD-MM-YYYY" },
  { label: "dd-MMM-yyyy (09-Jan-2026)", value: "DD-MMM-YYYY" },
  { label: "dd-MMMM-yyyy (09-January-2026)", value: "DD-MMMM-YYYY" },
  { label: "MM-dd-yyyy (01-09-2026)", value: "MM-DD-YYYY" },
  { label: "MMM-dd-yyyy (Jan-09-2026)", value: "MMM-DD-YYYY" },
  { label: "MMMM-dd-yyyy (January-09-2026)", value: "MMMM-DD-YYYY" },
  { label: "yyyy-MM-dd (2026-01-09)", value: "YYYY-MM-DD" },
  { label: "dd-MMMM (09-January)", value: "DD-MMMM" },
] as OptionType[];

export const dateSeparatorOptions = [
  { label: '(Default)', value: EDateSeparator.Default },
  { label: "/", value: EDateSeparator.Slash },
  { label: "-", value: EDateSeparator.Dash },
  { label: ".", value: EDateSeparator.Dot },
] as OptionType[];

export const firstDayOfWeekOptions = [
  { label: "(Default)", value: -1 },
  { label: "Sunday", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
] as OptionType[];